import type { IconProps } from '@/types/general'

export const Wikipedia = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="19"
		height="20"
		viewBox="0 0 19 20"
		fill="currentColor"
		className={props.className}
	>
		<g clipPath="url(#clip0_8_4754)">
			<path
				d="M9.5 0.502808C4.25347 0.502808 0 4.75628 0 10.0028C0 15.2493 4.25347 19.5028 9.5 19.5028C14.7465 19.5028 19 15.2493 19 10.0028C19 4.75628 14.7465 0.502808 9.5 0.502808ZM15.1011 7.7924C14.5609 9.01306 12.9087 12.8793 11.8062 15.3994C11.8047 15.4005 11.5174 15.3988 11.5166 15.3984L9.77795 11.3032C9.0889 12.6546 8.3254 14.0596 7.6725 15.3965C7.66861 15.4033 7.35664 15.3996 7.35626 15.3953C6.35815 13.0655 5.3233 10.7511 4.31995 8.42314C4.08767 7.85401 3.27286 6.93871 2.7152 6.94396C2.7152 6.87787 2.71209 6.73034 2.71131 6.64112L6.14823 6.64073L6.1455 6.93832C5.74198 6.95698 5.04457 7.21452 5.22534 7.66003C5.70972 8.70595 7.42487 12.7578 7.88845 13.7865C8.21189 13.1534 9.11514 11.4658 9.48717 10.7525C9.19561 10.1542 8.2321 7.92049 7.94326 7.35797C7.72537 6.99119 7.1786 6.94629 6.75759 6.93987C6.75759 6.84599 6.76245 6.77368 6.7607 6.64482L9.78184 6.65414V6.9286C9.37288 6.93987 8.98569 7.09207 9.16121 7.48315C9.56764 8.32673 9.80497 8.92734 10.178 9.70756C10.2971 9.47897 10.9078 8.22604 11.199 7.56478C11.3749 7.12511 11.1121 6.96048 10.3764 6.94065C10.3861 6.86834 10.3797 6.72315 10.3861 6.65395L12.9954 6.65648L12.9966 6.92879C12.5171 6.94745 12.0206 7.20286 11.7615 7.59938L10.5051 10.2051C10.6429 10.5498 11.8509 13.2335 11.9781 13.5311L14.5757 7.53524C14.3908 7.04989 13.8013 6.94143 13.5708 6.93618C13.5723 6.85882 13.5727 6.74084 13.5731 6.64229L16.2848 6.65006L16.2887 6.66367L16.2842 6.93463C15.6892 6.9527 15.3213 7.27089 15.1011 7.7924Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			{/* biome-ignore lint/correctness/useUniqueElementIds: SVG clipPath ID is scoped to this component */}
			<clipPath id="clip0_8_4754">
				<rect width="19" height="19" fill="white" transform="translate(0 0.502808)" />
			</clipPath>
		</defs>
	</svg>
)
